import React from 'react';
import { Flex, FieldSet, Legend, IconCircle } from '@zillow/constellation';
import { FieldConfig } from './MortgageRateTrends.utils.js';
import CheckboxField from '../Fields/CheckboxField.js';
import SelectField from '../Fields/SelectField.js';
import { PROGRAM_COLOR_CODE, LOAN_PROGRAMS } from './constants.js';

var LoanProgramLabel = function LoanProgramLabel(_ref) {
  var program = _ref.program,
    color = _ref.color;
  return /*#__PURE__*/React.createElement(Flex, {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(IconCircle, {
    style: {
      'margin-right': '6px'
    },
    size: "xs",
    color: color,
    display: "inline-block"
  }), LOAN_PROGRAMS[program]);
};
var MortgageRateTrendsFields = function MortgageRateTrendsFields() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: {
      default: 'column',
      md: 'row'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: "1 1 auto",
    marginRight: {
      lg: 'md'
    }
  }, /*#__PURE__*/React.createElement(FieldSet, {
    legend: /*#__PURE__*/React.createElement(Legend, null, "LOAN PROGRAMS")
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    label: /*#__PURE__*/React.createElement(LoanProgramLabel, {
      program: FieldConfig.Fixed30Year.name,
      color: PROGRAM_COLOR_CODE[FieldConfig.Fixed30Year.name]
    }),
    name: FieldConfig.Fixed30Year.name
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    label: /*#__PURE__*/React.createElement(LoanProgramLabel, {
      program: FieldConfig.Fixed20Year.name,
      color: PROGRAM_COLOR_CODE[FieldConfig.Fixed20Year.name]
    }),
    name: FieldConfig.Fixed20Year.name
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    label: /*#__PURE__*/React.createElement(LoanProgramLabel, {
      program: FieldConfig.Fixed15Year.name,
      color: PROGRAM_COLOR_CODE[FieldConfig.Fixed15Year.name]
    }),
    name: FieldConfig.Fixed15Year.name
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    label: /*#__PURE__*/React.createElement(LoanProgramLabel, {
      program: FieldConfig.Fixed10Year.name,
      color: PROGRAM_COLOR_CODE[FieldConfig.Fixed10Year.name]
    }),
    name: FieldConfig.Fixed10Year.name
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    label: /*#__PURE__*/React.createElement(LoanProgramLabel, {
      program: FieldConfig.ARM7.name,
      color: PROGRAM_COLOR_CODE[FieldConfig.ARM7.name]
    }),
    name: FieldConfig.ARM7.name
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    label: /*#__PURE__*/React.createElement(LoanProgramLabel, {
      program: FieldConfig.ARM5.name,
      color: PROGRAM_COLOR_CODE[FieldConfig.ARM5.name]
    }),
    name: FieldConfig.ARM5.name
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    label: /*#__PURE__*/React.createElement(LoanProgramLabel, {
      program: FieldConfig.ARM3.name,
      color: PROGRAM_COLOR_CODE[FieldConfig.ARM5.name]
    }),
    name: FieldConfig.ARM3.name
  }))), /*#__PURE__*/React.createElement(Flex, {
    flex: "1 1 auto",
    marginRight: {
      lg: 'md'
    }
  }, /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig.loanPurpose.options,
    label: "Loan purpose",
    name: FieldConfig.loanPurpose.name,
    config: FieldConfig.loanPurpose.config
  }), /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig.creditRating.options,
    label: "Credit rating",
    name: FieldConfig.creditRating.name,
    config: FieldConfig.creditRating.config
  }), /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig.percentDown.options,
    label: "Percent down",
    name: FieldConfig.percentDown.name,
    config: FieldConfig.percentDown.config
  }), /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig.location.options,
    label: "Location",
    name: FieldConfig.location.name,
    config: FieldConfig.location.config
  }), /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig.timeSpan.options,
    label: "Timespan",
    name: FieldConfig.timeSpan.name,
    config: FieldConfig.timeSpan.config
  }))));
};
var MortgageRateTrendsFields$1 = MortgageRateTrendsFields;

export { MortgageRateTrendsFields$1 as default };
